(function($, undefined) {
	'use strict';
	var asideCatEventItem;
	var timelineItemClone;
	var progToolAsideCtn;
	var mouseX = null;
	var mouseY = null;
	
	var toggleScheduleManager = function () {
		var btn = $(this);
		var settingsPopup = btn.closest('.stool-shared-popup');
		var component = $('.stool-component-settings-btn[data-id='+settingsPopup.attr('data-id')+']').closest('.com-program');

		component.find('.program-tool-ctn').slideDown();
		settingsPopup.find('.stool-shared-popup-close-btn').trigger('click');
		settingsPopup.removeClass('no-anim visible');
		$('body').removeClass('no-scroll');
		$('html,body').animate({ scrollTop: component.find('.program-tool-ctn').offset().top - 100 }, 'slow');
	};
	
	var toggleAsideCat = function () {
		var t = $(this);
		var currCat = t.closest('.program-tool-list-cat');
		var currCatContent = $('.program-tool-list-cat-content', currCat);
		var aside = t.closest('aside');
		
		if (currCat.hasClass('open')) {
			currCat.removeClass('open');
			currCatContent.slideUp(200);
		} else {
			aside.find('.program-tool-list-cat.open').removeClass('open');
			aside.find('.program-tool-list-cat-content').slideUp(200);
			currCat.addClass('open');
			currCatContent.slideDown(200);
		}
	};

	var editEdit = function () {
		var t = $(this);
		var ctn = t.closest('.program-tool-ctn');
		var id = t.closest('.program-tool-timeline-item-events-item').attr('data-id') || t.closest('.program-tool-list-cat-list-item').attr('data-id');
		var popupBtn = $('button[data-popup-id="conferences-list-' + ctn.attr('data-text-id') + '"]');
		var popup = $('.gen-list-popup[data-popup-id="conferences-list-' + ctn.attr('data-text-id') + '"]');
		var scrollingCtn = popup.find('.popup-default-content-ctn');
		var popupItem = popup.find('.gen-list-popup-item[data-id='+id+']');

		popup.find('.gen-list-popup-item').removeClass('open');
		$(scrollingCtn).animate({ scrollTop: 0 });

		popupBtn.trigger('click');

		setTimeout(function() {
			var target = popupItem.offset().top + $(scrollingCtn).scrollTop() - $(scrollingCtn).offset().top;
			$(scrollingCtn).animate({ scrollTop: target }, 'slow');
			popupItem.addClass('open');
		}, 500);
	};
	
	var changeTimelineTabClick = function () {
		var t = $(this);
		var tabCtn = t.closest('.program-tool-timeline-tab-ctn');
		var date = t.attr('data-date');
		var timelineTabsCtn = t.closest('.program-tool-timeline-tabs-ctn');
		var component = t.closest('.com-program');
		
		if (!tabCtn.hasClass('selected')) {
			timelineTabsCtn.find('.program-tool-timeline-tab-ctn').removeClass('selected');
			tabCtn.addClass('selected');
			
			$('.program-tool-timeline-item', component).removeClass('selected');
			$('.program-tool-timeline-item[data-date="'+date+'"]', component).addClass('selected');
		}
	};
	
	var fixHelper = function (e, ui) {            
	    ui.children().each(function () {
	        $(this).width($(this).width());
	    });
	    return ui;
	};
	
	function allElementsFromPoint(x, y, clazz) {
	    var element, elements = [];
	    var old_visibility = [];
        var breaker = 1000;
        
	    while (breaker > 0) {
	        element = document.elementFromPoint(x, y);
	        if (!element || element === document.documentElement || element.isSameNode(elements[elements.length - 1])) {
	            break;
	        }
            breaker--;
	        elements.push(element);
	        old_visibility.push(element.style.visibility);
	        element.style.visibility = 'hidden'; // Temporarily hide the element (without changing the layout)
            // Target element found, break the loop
            if (clazz && element.classList.contains(clazz)) {
                break;
            }
	    }
	    for (var k = 0; k < elements.length; k++) {
	        elements[k].style.visibility = old_visibility[k];
	    }
	    elements.reverse();
	    return elements;
	}
	
	var eventStopDrag = function(e, ui) {
		var x = mouseX;
		var y = mouseY;
		var elementSMouseIsOver = allElementsFromPoint(x, y, 'program-tool-timeline-grid-item');
		var gridItem = '';
		
		for(var i=0; i<elementSMouseIsOver.length;i++) {
            if (elementSMouseIsOver[i].classList.contains('program-tool-timeline-grid-item')) {
                gridItem = elementSMouseIsOver[i];
            }
		}
		
		placeEventOnGrid($(gridItem), $(ui.item));
	};
	
	var placeEventOnGrid = function (gridItem, dragItem) {
		if (!gridItem.hasClass('has-event')) {
			var eventGridCtn = gridItem.closest('.program-tool-timeline-item.selected');
			var eventGrid = $('.program-tool-timeline-item-events', eventGridCtn);
			var dragItemCtn = dragItem.closest('.program-tool-list-cat-list-item');
			var dragItemCatCtn = dragItemCtn.closest('.program-tool-list-cat');
			var cat = dragItemCatCtn.attr('data-label-id');
			var itemData = JSON.parse(dragItemCtn.attr('data-data'));
			var eventId = dragItemCtn.attr('data-id');
			var currItemUniqueId = eventGrid.attr('data-num-items');
			
			var timeUnit = gridItem.attr('data-time-unit');
			var col = gridItem.attr('data-col');
			
			var newElt = eventGridCtn.closest('.com-program').find(timelineItemClone).clone().removeClass('clone');
			newElt.attr('data-id', eventId);
			newElt.attr('data-time-unit', timeUnit);
			newElt.attr('data-time-unit-span', '1');
			newElt.attr('data-col', col);
			newElt.attr('data-col-span', '1');
			newElt.attr('data-cat', cat);
			newElt.attr('data-unique-id', currItemUniqueId);
			newElt.find('.program-tool-timeline-item-events-item-inner').attr('style', dragItemCatCtn.attr('style'));
			
			$('.program-tool-timeline-item-events-item-title', newElt).html(itemData['title-' + $('html').attr('lang')]);
			
			positionEventsOnGrid(newElt, eventGridCtn, false);
			eventGrid.append(newElt);
			addEventsItemsListener(newElt);
			eventGrid.attr('data-num-items', currItemUniqueId+1);
		}
	};
	
	var positionEventsOnGrid = function (items, currGrid, anim) {
		var nbOfCol = currGrid.attr('data-nb-cols');
		var defaultHourUnit = parseInt(currGrid.attr('data-time-unit-start'));
		var itemHeight = currGrid.closest('.com-program').find(timelineItemClone).outerHeight();
		var isAnim = anim === undefined ? true : false;
		
		items.each(function() {
			var t = $(this);
			var tCol = parseInt(t.attr('data-col'));
			var tTimeUnit = parseInt(t.attr('data-time-unit'));
			
			var newTop = itemHeight * (tTimeUnit - defaultHourUnit);
			var newLeft = ((100 / nbOfCol) * tCol) + '%';
			
			//if (isAnim) {
			//	t.animate({top: newTop, left: newLeft}, 200);
			//} else {
				t.css({top: newTop, left: newLeft});
			//}
			
			reserveGridSpot(t, currGrid);
		});
	};
	
	var submitTimelines = function () {
		var btn = $(this);
		var timelinesCtn = btn.closest('.program-tool-timeline');
		var timeline = btn.closest('.program-tool-timeline-item');
		var id = timeline.attr('data-id');
		var events = {};
		var eventsHtml = '<program>';
		var successMsg = timeline.find('.form-message_success.timeline');
		var errorMsg = timeline.find('.error-occured');

		timelinesCtn.addClass('has-processing_active');
		successMsg.slideUp();
		errorMsg.slideUp();
		
		$('.program-tool-timeline-item-events-item:not(.clone)', timeline).sort(function(a,b) {
			return $(a).data('time-unit') - $(b).data('time-unit') || $(a).data('col') - $(b).data('col');
		}).appendTo('.program-tool-timeline-item-events', timeline);

		console.log($('.program-tool-timeline-item-events .program-tool-timeline-item-events-item:not(.clone)', timeline).length);

		$('.program-tool-timeline-item-events-item:not(.clone)', timeline).each(function(i) {
			var event = $(this);
			var id = event.attr('data-id');
			var timeUnit = event.attr('data-time-unit');
			var timeUnitSpan = event.attr('data-time-unit-span');
			var col = event.attr('data-col');
			var colSpan = event.attr('data-col-span');
			var cat = event.attr('data-cat');
			
			events[i] = {
				id: id,
				timeUnit: timeUnit,
				timeUnitSpan: timeUnitSpan,
				col: col,
				colSpan: colSpan,
				cat: cat
			};
			eventsHtml += `<conference id="${id}" timeUnit="${timeUnit}" timeUnitSpan="${timeUnitSpan}" col="${col}" colSpan="${colSpan}" cat="${cat}"></conference>`;
		});
		
		eventsHtml += '</program>';

		var data = {
			id: id,
			field29: JSON.stringify(events).replace(/\\n/g, "")
						 .replace(/\\'/g, "'")
						 .replace(/\\"/g, '"')
						 .replace(/\\&/g, "")
						 .replace(/\\r/g, "")
						 .replace(/\\t/g, "")
						 .replace(/\\b/g, "")
						 .replace(/\\f/g, ""),
			extraData: eventsHtml,
			ajax: true
		};

		console.log(data);
		
		$.ajax({
			url: '/action/manageGenData',
			cache: false,
			data: data,
			method: 'POST',
			success : function (data) {
				console.log('program saved. Msg : ' + data);

				if (data.indexOf('success') !== -1) {
					successMsg.slideDown();
					setTimeout(function() {
						successMsg.slideUp();
					}, 5000);
				} else {
					errorMsg.slideDown();
					setTimeout(function() {
						errorMsg.slideUp();
					}, 5000);
				}

				timelinesCtn.removeClass('has-processing_active');
			}
		});
	};
	
	var initEventsItems = function () {
		$('.program-tool-timeline-item-events').each(function () {
			var t = $(this);
			var currGrid = t.closest('.program-tool-timeline-item');
			var jsonString = t.attr('data-eventsjson') === '' ? "{}" : t.attr('data-eventsjson');
			var events = JSON.parse(jsonString);
			var currItemUniqueId = 0;
			
			for(var event in events) {
				var eventId = events[event].id;
				var eventTimeUnit = events[event].timeUnit;
				var eventTimeUnitSpan = events[event].timeUnitSpan;
				var eventCol = events[event].col;
				var eventColSpan = events[event].colSpan;
				var eventCat = events[event].cat;
				var title = $('.program-tool-list-cat-list-item[data-id="'+eventId+'"] .program-tool-list-cat-list-item-name').html();
				
				var newElt = currGrid.closest('.com-program').find(timelineItemClone).clone().removeClass('clone');
				newElt.attr('data-id', eventId);
				newElt.attr('data-time-unit', eventTimeUnit);
				newElt.attr('data-time-unit-span', eventTimeUnitSpan);
				newElt.attr('data-col', eventCol);
				newElt.attr('data-col-span', eventColSpan);
				newElt.attr('data-cat', eventCat);
				newElt.attr('data-unique-id', currItemUniqueId);
				newElt.find('.program-tool-timeline-item-events-item-inner').attr('style', $('.program-tool-list-cat[data-label-id='+eventCat+']').attr('style'));
			
				$('.program-tool-timeline-item-events-item-title', newElt).html(title);
				
				positionEventsOnGrid(newElt, currGrid, false);
				t.append(newElt);
				addEventsItemsListener(newElt);
				currItemUniqueId++;
			}
			
			t.attr('data-num-items', Object.keys(events).length);
			t.addClass('inited');
		});

		if ($('.program-tool-timeline-item-events').length === $('.program-tool-timeline-item-events.inited').length) {
			$('.program-tool-timeline').removeClass('has-processing_active');
		}
	};
	
	var addEventsItemsListener = function (elt) {
		var currGrid = elt.closest('.program-tool-timeline-item');
		
		$('.program-tool-timeline-item-events-item-inner', elt).click(eventsItemOpenMCP);
		$('.program-tool-timeline-item-events-item-mcp-btn.edit', elt).click(eventItemEdit);
		$('.program-tool-timeline-item-events-item-mcp-btn.scale', elt).click(eventItemScale);
		$('.program-tool-timeline-item-events-item-mcp-btn.del', elt).click(eventItemDel);
		
		$('.program-tool-timeline-item-events-item-scale-btn.top.more', elt).click(function () {
			elt.attr('data-time-unit', parseInt(elt.attr('data-time-unit')) - 1);
			elt.attr('data-time-unit-span', parseInt(elt.attr('data-time-unit-span')) + 1);
			removeGridSpot(elt.attr('data-unique-id'));
			positionEventsOnGrid(elt, currGrid);
			checkForScale(elt);
		});
		$('.program-tool-timeline-item-events-item-scale-btn.bottom.more', elt).click(function () {
			elt.attr('data-time-unit-span', parseInt(elt.attr('data-time-unit-span')) + 1);
			removeGridSpot(elt.attr('data-unique-id'));
			positionEventsOnGrid(elt, currGrid);
			checkForScale(elt);
		});
		$('.program-tool-timeline-item-events-item-scale-btn.right.more', elt).click(function () {
			elt.attr('data-col-span', parseInt(elt.attr('data-col-span')) + 1);
			removeGridSpot(elt.attr('data-unique-id'));
			positionEventsOnGrid(elt, currGrid);
			checkForScale(elt);
		});
		$('.program-tool-timeline-item-events-item-scale-btn.left.more', elt).click(function () {
			elt.attr('data-col', parseInt(elt.attr('data-col')) - 1);
			elt.attr('data-col-span', parseInt(elt.attr('data-col-span')) + 1);
			removeGridSpot(elt.attr('data-unique-id'));
			positionEventsOnGrid(elt, currGrid);
			checkForScale(elt);
		});
		
		$('.program-tool-timeline-item-events-item-scale-btn.top.less', elt).click(function () {
			elt.attr('data-time-unit', parseInt(elt.attr('data-time-unit')) + 1);
			elt.attr('data-time-unit-span', parseInt(elt.attr('data-time-unit-span')) - 1);
			removeGridSpot(elt.attr('data-unique-id'));
			positionEventsOnGrid(elt, currGrid);
			checkForScale(elt);
		});
		$('.program-tool-timeline-item-events-item-scale-btn.bottom.less', elt).click(function () {
			elt.attr('data-time-unit-span', parseInt(elt.attr('data-time-unit-span')) - 1);
			removeGridSpot(elt.attr('data-unique-id'));
			positionEventsOnGrid(elt, currGrid);
			checkForScale(elt);
		});
		$('.program-tool-timeline-item-events-item-scale-btn.right.less', elt).click(function () {
			elt.attr('data-col-span', parseInt(elt.attr('data-col-span')) - 1);
			removeGridSpot(elt.attr('data-unique-id'));
			positionEventsOnGrid(elt, currGrid);
			checkForScale(elt);
		});
		$('.program-tool-timeline-item-events-item-scale-btn.left.less', elt).click(function () {
			elt.attr('data-col', parseInt(elt.attr('data-col')) + 1);
			elt.attr('data-col-span', parseInt(elt.attr('data-col-span')) - 1);
			removeGridSpot(elt.attr('data-unique-id'));
			positionEventsOnGrid(elt, currGrid);
			checkForScale(elt);
		});
	};
	
	var eventsItemOpenMCP = function () {
		var t = $(this);
		var event = t.closest('.program-tool-timeline-item-events-item');
		
		if (!event.hasClass('show-controls')) {
			$('.program-tool-timeline-item-events-item').removeClass('show-mcp show-controls');
			event.addClass('show-mcp');
		}
	};
	
	var eventItemEdit = function () {
		var t = $(this);
		var event = t.closest('.program-tool-timeline-item-events-item');
		var eventId = event.attr('data-id');
		var catItem = $('.program-tool-list-cat-list-item[data-id="'+eventId+'"]');
		
		editEdit.apply(catItem);
	};
	
	var eventItemScale = function () {
		var t = $(this);
		var event = t.closest('.program-tool-timeline-item-events-item');
		
		checkForScale(event);
		event.removeClass('show-mcp').addClass('show-controls');
	};
	
	var eventItemDel = function () {
		var t = $(this);
		var event = t.closest('.program-tool-timeline-item-events-item');
		event.remove();
		
		removeGridSpot(event.attr('data-unique-id'));
	};
	
	var delEventOnGrids = function (id) {
		var event = $('.program-tool-timeline-item-events-item[data-id="'+id+'"]');
		event.remove();
		
		removeEventsWithIdGridSpot(id);
	};
	
	var checkForScale = function (elt) {
		var canScaleTop = true;
		var canShrinkTop = true;
		var canScaleBottom = true;
		var canShrinkBottom = true;
		var canScaleRight = true;
		var canShrinkRight = true;
		var canScaleLeft = true;
		var canShrinkLeft = true;
		var currTimeline = elt.closest('.program-tool-timeline-item');
		
		var timeUnit = parseInt(elt.attr('data-time-unit'));
		var timeUnitSpan = parseInt(elt.attr('data-time-unit-span'));
		var timeUnitMax = (timeUnit + timeUnitSpan) - 1;
		var col = parseInt(elt.attr('data-col'));
		var colSpan = parseInt(elt.attr('data-col-span'));
		var colMax = (col + colSpan) - 1;
		
		var timelineMinCol = 0;
		var timelineMaxCol = parseInt(currTimeline.attr('data-nb-cols')) - 1;
		var timelineMinTimeUnit = parseInt(currTimeline.attr('data-time-unit-start'));
		var timelineMaxTimeUnit = parseInt(currTimeline.attr('data-time-unit-end'));
		
		$('.program-tool-timeline-item-events-item-scale-btn', currTimeline).removeAttr('disabled');
		
		//Limits
		if (col === timelineMinCol) {
			canScaleLeft = false;
		} else {
			var prevVerticalItems = $('.program-tool-timeline-grid-item[data-col="'+(col - 1)+'"].has-event', currTimeline).filter(function () {
				var currMin = $(this).data('time-unit');
				return currMin >= timeUnit && currMin <= timeUnitMax;
			});
			
			if (prevVerticalItems.length !== 0) {
				canScaleLeft = false;
			}
		}
		if (colMax >= timelineMaxCol) {
			canScaleRight = false;
		} else {
			var nextVerticalItems = $('.program-tool-timeline-grid-item[data-col="'+(colMax + 1)+'"].has-event', currTimeline).filter(function () {
				var CurrMin = $(this).data('time-unit');
				return CurrMin >= timeUnit && CurrMin <= timeUnitMax;
			});
			
			if (nextVerticalItems.length !== 0) {
				canScaleRight = false;
			}
		}
		if (timeUnit === timelineMinTimeUnit) {
			canScaleTop = false;
		} else {
			var prevHorizontalItems = $('.program-tool-timeline-grid-item[data-time-unit="'+(timeUnit - 1)+'"].has-event', currTimeline).filter(function () {
				var currCol = $(this).data('col');
				return currCol >= col && currCol <= colMax;
			});
			
			if (prevHorizontalItems.length !== 0) {
				canScaleTop = false;
			}
		}
		if (timeUnitMax === timelineMaxTimeUnit) {
			canScaleBottom = false;
		} else {
			var nextHorizontalItems = $('.program-tool-timeline-grid-item[data-time-unit="'+(timeUnitMax + 1)+'"].has-event', currTimeline).filter(function () {
				var currCol = $(this).data('col');
				return currCol >= col && currCol <= colMax;
			});
			
			if (nextHorizontalItems.length !== 0) {
				canScaleBottom = false;
			}
		}
		//Inner minimum
		if (timeUnitSpan === 1) {
			canShrinkTop = false;
			canShrinkBottom = false;
		}
		if (colSpan === 1) {
			canShrinkRight = false;
			canShrinkLeft = false;
		}
		
		if (!canScaleTop) {
			$('.program-tool-timeline-item-events-item-scale-btn.top.more', elt).attr('disabled', 'disabled');
		}
		if (!canScaleBottom) {
			$('.program-tool-timeline-item-events-item-scale-btn.bottom.more', elt).attr('disabled', 'disabled');
		}
		if (!canScaleRight) {
			$('.program-tool-timeline-item-events-item-scale-btn.right.more', elt).attr('disabled', 'disabled');
		}
		if (!canScaleLeft) {
			$('.program-tool-timeline-item-events-item-scale-btn.left.more', elt).attr('disabled', 'disabled');
		}
		
		if (!canShrinkTop) {
			$('.program-tool-timeline-item-events-item-scale-btn.top.less', elt).attr('disabled', 'disabled');
		}
		if (!canShrinkBottom) {
			$('.program-tool-timeline-item-events-item-scale-btn.bottom.less', elt).attr('disabled', 'disabled');
		}
		if (!canShrinkRight) {
			$('.program-tool-timeline-item-events-item-scale-btn.right.less', elt).attr('disabled', 'disabled');
		}
		if (!canShrinkLeft) {
			$('.program-tool-timeline-item-events-item-scale-btn.left.less', elt).attr('disabled', 'disabled');
		}
	};
	
	var removeGridSpot = function (id) {
		$('.program-tool-timeline-grid-item[data-unique-id="'+id+'"]').removeClass('has-event').removeAttr('data-event-id').removeAttr('data-unique-id');
	};
	
	var removeEventsWithIdGridSpot = function (id) {
		$('.program-tool-timeline-grid-item[data-event-id="'+id+'"]').removeClass('has-event').removeAttr('data-event-id').removeAttr('data-unique-id');
	};
	
	var reserveGridSpot = function (elt, currGrid) {
		var timeUnit = parseInt(elt.attr('data-time-unit'));
		var timeUnitSpan = parseInt(elt.attr('data-time-unit-span'));
		var timeUnitMax = (timeUnit + timeUnitSpan) - 1;
		var col = parseInt(elt.attr('data-col'));
		var colSpan = parseInt(elt.attr('data-col-span'));
		var colMax = (col + colSpan) - 1;
		var uniqueId = elt.attr('data-unique-id');
		
		var selectedGridItems = $('.program-tool-timeline-grid-item', currGrid).filter(function () {
			var min = $(this).data('time-unit');
			var currCol = $(this).data('col');
			return min >= timeUnit && min <= timeUnitMax && currCol >= col && currCol <= colMax;
		});
		
		selectedGridItems.addClass('has-event').attr('data-event-id', elt.attr('data-id')).attr('data-unique-id', uniqueId);
	};
	
	var outsideEventItemClick = function (event) {
		if (!$(event.target).closest('.program-tool-timeline-item-events-item').length) {
			$('.program-tool-timeline-item-events-item').removeClass('show-mcp show-controls');
		}
	};
	
	var checkProgToolAsideDock = function () {
		var scroll = window.scrollY;
		var winH = window.innerHeight;
		var scrollBottom = scroll + winH;

		progToolAsideCtn.each(function() {
			var t = $(this);
			var progToolAside = $('.program-tool-list-inner', t);
			var progToolTop = t.offset().top;
			var progToolBottom = progToolTop + t.height();
			var progToolLeft = t.offset().left;
			var progToolWidth = t.width();
			
			if (scroll < progToolTop) {
				progToolAside.removeClass('docked docked-bottom');
			} else if (scroll >= progToolTop && scrollBottom < progToolBottom) {
				progToolAside.addClass('docked').removeClass('docked-bottom');
				progToolAside.css('left', progToolLeft + 'px');
				progToolAside.css('width', progToolWidth + 'px');
			} else {
				progToolAside.addClass('docked-bottom').removeClass('docked');
			}
		});
	};

	var openCategoryPopup = function() {
		var ctn = $(this).closest('.program-tool-ctn');
		var popupBtn = $('button[data-popup-id="program-categories-list-' + ctn.attr('data-text-id') + '"]');

		popupBtn.trigger('click');
	};

	var openConferencePopup = function() {
		var ctn = $(this).closest('.program-tool-ctn');
		var popupBtn = $('button[data-popup-id="conferences-list-' + ctn.attr('data-text-id') + '"]');

		popupBtn.trigger('click');
	};
	
	var init = function () {
		asideCatEventItem = $('.program-tool-list-cat-list-item');
		timelineItemClone = $('.program-tool-timeline-item-events-item.clone');
		progToolAsideCtn = $('.program-tool-list');
		
		if (asideCatEventItem.length > 0) {		
			asideCatEventItem.sortable({
				helper: fixHelper,
				handle: '.program-tool-list-cat-list-item-handle',
				items: '.program-tool-list-cat-list-item-inner',
				stop: function (e, ui) {
					eventStopDrag(e, ui);
				}
			});
		}

		$(document).on('mousemove', function (e) {
			mouseX = e.clientX;
			mouseY = e.clientY;
		});
		
		initEventsItems();
		
		$(document).on('click', outsideEventItemClick);
		$('.program-tool-list-cat-list-item-edit').click(editEdit);
		$('.program-tool-list-toggle').click(toggleAsideCat);
		$('.program-tool-timeline-btn').click(submitTimelines);
		$('.program-tool-timeline-tab').click(changeTimelineTabClick);
		$('.com-program-add-category-btn').click(openCategoryPopup);
		$('.com-program-add-conference-btn').click(openConferencePopup);
		$('.js-toggle-schedule').click(toggleScheduleManager);
		
		if (progToolAsideCtn.length !== 0) {
			checkProgToolAsideDock();
			
			$(window).scroll(function () {
				checkProgToolAsideDock();
			});
		}
	};
	
	$(window).ready(init);
})(jQuery);